import { Button, Row } from "antd";
import { ClockCircleOutlined, SyncOutlined } from "@ant-design/icons";
import dayjs from "../../../configs/dayjs";
import { useCancelEmail } from "../hooks/useCancelEmail";
import { useMemo } from "react";

type CancelPanelProps = {
  id: string;
  data: any;
  onCanceled: () => void;
};

export const CancelPanel = ({ id, data, onCanceled }: CancelPanelProps) => {
  const { disabled, remove } = useCancelEmail(id, onCanceled);

  const recurrentInfo: string = useMemo(() => {
    const { scheduledDate, endConditionType, endDate, occurrencesLeft } = data;

    let val: string = `Repeat yearly on ${dayjs(scheduledDate).format("MMM D")}, `;

    if (endConditionType === 1) {
      val += `${occurrencesLeft} occurrences left`;
    }

    if (endConditionType === 2) {
      val += `until ${dayjs(endDate).format("MMM D, YYYY")}`;
    }

    if (endConditionType === 3) {
      val += "until account is closed";
    }

    return val;
  }, [data]);

  return (
    <Row className="cancel-panel w-100 px-4 py-2 align-center mb-6 justify-space-between">
      <Row className="d-block align-center">
        <Row>
          {data.frequencyType === 1 ? (
            <ClockCircleOutlined className="mr-2" />
          ) : (
            <SyncOutlined className="mr-2" />
          )}
          <span>
            Send scheduled for{" "}
            {dayjs(data.scheduledDate).format("ddd, MMMM D, YYYY")}, 8:00 AM
          </span>
        </Row>
        {data.frequencyType === 2 && (
          <span className="text-sm recurring-settings">{recurrentInfo}</span>
        )}
      </Row>
      <Button type="link" className="px-0" disabled={disabled} onClick={remove}>
        Cancel Send
      </Button>
    </Row>
  );
};
